module.exports = __webpack_public_path__ + "static/media/roombox_logo_text.3b689dd1.svg";